import { useSelector } from 'react-redux';
import { State } from '../core/reducers';
import { AccountSpecificFeature } from '@api/v1';

/**
 * Returns true if the current account has the account-specific feature.
 */
export function useAccountSpecificFeature(accountSpecificFeature: `${AccountSpecificFeature}`) {
	const features: string[] = useSelector(
		(state: State) => state.auth.user?.accountSpecificFeatures || []
	);
	return features?.includes(accountSpecificFeature);
}

export { AccountSpecificFeature };
